export default __webpack_public_path__ + "img/admin-settings.0aac1e.svg";